export default __webpack_public_path__ + "static/media/bot.2a34a0ab.png";